import { render, staticRenderFns } from "./BillReceivablePartialPrint.vue?vue&type=template&id=cb624ac2&scoped=true"
import script from "./BillReceivablePartialPrint.vue?vue&type=script&lang=js"
export * from "./BillReceivablePartialPrint.vue?vue&type=script&lang=js"
import style0 from "./BillReceivablePartialPrint.vue?vue&type=style&index=0&id=cb624ac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb624ac2",
  null
  
)

export default component.exports